var map = {
	"./": [
		52083,
		9
	],
	"./App": [
		9555,
		9
	],
	"./App.css": [
		93508,
		9,
		3508
	],
	"./App.js": [
		9555,
		9
	],
	"./App.test": [
		52737,
		9,
		5844,
		9607,
		2449
	],
	"./App.test.js": [
		52737,
		9,
		5844,
		9607,
		2449
	],
	"./assets/body-bg.jpg": [
		90298,
		1,
		298
	],
	"./assets/body-repeat-bg.jpg": [
		46903,
		1,
		6903
	],
	"./assets/body-watermark.png": [
		53463,
		1,
		3463
	],
	"./assets/ch.png": [
		46851,
		1
	],
	"./assets/css/authen.css": [
		48579,
		9,
		8579
	],
	"./assets/css/fancybox.min.css": [
		75509,
		9
	],
	"./assets/css/fonts/Kanit-Regular.ttf": [
		5442,
		1,
		5442
	],
	"./assets/css/styles.css": [
		39173,
		9
	],
	"./assets/en.jpg": [
		41009,
		1
	],
	"./assets/footer-bg.png": [
		51243,
		1,
		1243
	],
	"./assets/header-bg.png": [
		89915,
		1,
		9915
	],
	"./assets/logo.png": [
		66949,
		1,
		6949
	],
	"./assets/main-logo.png": [
		54413,
		1
	],
	"./assets/pattern-bg1.png": [
		63457,
		1,
		3457
	],
	"./assets/shelf-2.png": [
		14297,
		1,
		4297
	],
	"./assets/slide.png": [
		52568,
		1
	],
	"./assets/th.jpg": [
		80485,
		1
	],
	"./components/Footer": [
		50321,
		9
	],
	"./components/Footer.jsx": [
		50321,
		9
	],
	"./components/Homepage/Exhibition": [
		27092,
		9
	],
	"./components/Homepage/Exhibition.jsx": [
		27092,
		9
	],
	"./components/Homepage/Gallery": [
		71808,
		9
	],
	"./components/Homepage/Gallery.jsx": [
		71808,
		9
	],
	"./components/Homepage/Knowledge": [
		65529,
		9
	],
	"./components/Homepage/Knowledge.jsx": [
		65529,
		9
	],
	"./components/Homepage/News": [
		14243,
		9
	],
	"./components/Homepage/News.jsx": [
		14243,
		9
	],
	"./components/Homepage/NewsCard": [
		38478,
		9
	],
	"./components/Homepage/NewsCard.jsx": [
		38478,
		9
	],
	"./components/Homepage/Slide": [
		76659,
		9
	],
	"./components/Homepage/Slide.jsx": [
		76659,
		9
	],
	"./components/Layout": [
		96207,
		9
	],
	"./components/Layout.jsx": [
		96207,
		9
	],
	"./components/ScrollToTop": [
		7788,
		9
	],
	"./components/ScrollToTop.jsx": [
		7788,
		9
	],
	"./components/Template/Article/ActivityArticle": [
		3876,
		9,
		3876
	],
	"./components/Template/Article/ActivityArticle.jsx": [
		3876,
		9,
		3876
	],
	"./components/Template/Article/ExArticle": [
		46926,
		9,
		6926
	],
	"./components/Template/Article/ExArticle.jsx": [
		46926,
		9,
		6926
	],
	"./components/Template/Article/Gallery": [
		84166,
		9,
		4166
	],
	"./components/Template/Article/Gallery.jsx": [
		84166,
		9,
		4166
	],
	"./components/Template/Article/Header": [
		80997,
		9,
		997
	],
	"./components/Template/Article/Header.jsx": [
		80997,
		9,
		997
	],
	"./components/Template/Article/KmArticle": [
		2372,
		9,
		2372
	],
	"./components/Template/Article/KmArticle.jsx": [
		2372,
		9,
		2372
	],
	"./components/Template/Article/Menu": [
		69284,
		9,
		9284
	],
	"./components/Template/Article/Menu.jsx": [
		69284,
		9,
		9284
	],
	"./components/Template/Article/NewsArticle": [
		72011,
		9,
		2011
	],
	"./components/Template/Article/NewsArticle.jsx": [
		72011,
		9,
		2011
	],
	"./components/Template/Article/Vdo": [
		50920,
		9,
		920
	],
	"./components/Template/Article/Vdo.jsx": [
		50920,
		9,
		920
	],
	"./components/Template/Article/widgets/Content": [
		10772,
		9,
		772
	],
	"./components/Template/Article/widgets/Content.jsx": [
		10772,
		9,
		772
	],
	"./components/Template/Article/widgets/Gallery": [
		80989,
		9,
		989
	],
	"./components/Template/Article/widgets/Gallery.jsx": [
		80989,
		9,
		989
	],
	"./components/Template/Article/widgets/Header": [
		67110,
		9,
		7110
	],
	"./components/Template/Article/widgets/Header.jsx": [
		67110,
		9,
		7110
	],
	"./components/Template/Article/widgets/LeftImage": [
		66281,
		9,
		6281
	],
	"./components/Template/Article/widgets/LeftImage.jsx": [
		66281,
		9,
		6281
	],
	"./components/Template/Article/widgets/Map": [
		59384,
		9,
		9384
	],
	"./components/Template/Article/widgets/Map.jsx": [
		59384,
		9,
		9384
	],
	"./components/Template/Article/widgets/Slide": [
		90184,
		9,
		184
	],
	"./components/Template/Article/widgets/Slide.jsx": [
		90184,
		9,
		184
	],
	"./components/Template/Swiper/SwiperNavigation": [
		16956,
		9
	],
	"./components/Template/Swiper/SwiperNavigation.jsx": [
		16956,
		9
	],
	"./components/Template/fancybox": [
		21943,
		9
	],
	"./components/Template/fancybox.jsx": [
		21943,
		9
	],
	"./components/api": [
		51256,
		9
	],
	"./components/api.js": [
		51256,
		9
	],
	"./hmk84db.sql": [
		3717,
		1,
		3717
	],
	"./index": [
		52083,
		9
	],
	"./index.css": [
		51174,
		9,
		1174
	],
	"./index.js": [
		52083,
		9
	],
	"./lang": [
		92327,
		9
	],
	"./lang.js": [
		92327,
		9
	],
	"./lazyLoad": [
		27157,
		9
	],
	"./lazyLoad.js": [
		27157,
		9
	],
	"./logo.svg": [
		31100,
		1,
		1100
	],
	"./reportWebVitals": [
		54013,
		9
	],
	"./reportWebVitals.js": [
		54013,
		9
	],
	"./routes/Routes": [
		64407,
		9,
		4407
	],
	"./routes/Routes.jsx": [
		64407,
		9,
		4407
	],
	"./setupTests": [
		79511,
		9,
		5844,
		4089,
		5708
	],
	"./setupTests.js": [
		79511,
		9,
		5844,
		4089,
		5708
	],
	"./sum": [
		19131,
		9,
		9131
	],
	"./sum.js": [
		19131,
		9,
		9131
	],
	"./usertrack/assets/Screenshot 2023-07-26 103000.png": [
		2442,
		1,
		2442
	],
	"./usertrack/assets/cn.jpg": [
		78912,
		1,
		8912
	],
	"./usertrack/assets/css/main.module.css": [
		98364,
		9,
		8364
	],
	"./usertrack/assets/en.jpg": [
		41041,
		1,
		1041
	],
	"./usertrack/assets/main-logo.jpg": [
		5570,
		1,
		5570
	],
	"./usertrack/assets/main-logo.png": [
		94193,
		1,
		4193
	],
	"./usertrack/assets/main-logo.psd": [
		91680,
		1,
		1680
	],
	"./usertrack/assets/th.jpg": [
		20624,
		1,
		624
	],
	"./usertrack/assets/user1.png": [
		59494,
		1,
		9494
	],
	"./usertrack/assets/user2.png": [
		82099,
		1,
		2099
	],
	"./usertrack/assets/user3.png": [
		31612,
		1,
		1612
	],
	"./usertrack/assets/user4.png": [
		14295,
		1,
		4295
	],
	"./usertrack/components/Footer": [
		60854,
		9,
		854
	],
	"./usertrack/components/Footer.jsx": [
		60854,
		9,
		854
	],
	"./usertrack/components/Layout": [
		26530,
		9,
		8180
	],
	"./usertrack/components/Layout.jsx": [
		26530,
		9,
		8180
	],
	"./usertrack/components/ScrollToTop": [
		5690,
		9,
		5690
	],
	"./usertrack/components/ScrollToTop.jsx": [
		5690,
		9,
		5690
	],
	"./usertrack/components/api": [
		64063,
		9,
		4063
	],
	"./usertrack/components/api.js": [
		64063,
		9,
		4063
	],
	"./usertrack/context/ThemeContext": [
		42653,
		9,
		2653
	],
	"./usertrack/context/ThemeContext.jsx": [
		42653,
		9,
		2653
	],
	"./usertrack/views/Callback": [
		6918,
		9,
		6918
	],
	"./usertrack/views/Callback.jsx": [
		6918,
		9,
		6918
	],
	"./usertrack/views/Home": [
		66391,
		9,
		6391
	],
	"./usertrack/views/Home.jsx": [
		66391,
		9,
		6391
	],
	"./views/About": [
		60347,
		9,
		347
	],
	"./views/About.jsx": [
		60347,
		9,
		347
	],
	"./views/Activities": [
		11224,
		9,
		1224
	],
	"./views/Activities.jsx": [
		11224,
		9,
		1224
	],
	"./views/AdminData": [
		45661,
		9,
		5661
	],
	"./views/AdminData.jsx": [
		45661,
		9,
		5661
	],
	"./views/Article": [
		71220,
		9,
		1220
	],
	"./views/Article.jsx": [
		71220,
		9,
		1220
	],
	"./views/Exhibitions": [
		68154,
		9,
		8154
	],
	"./views/Exhibitions.jsx": [
		68154,
		9,
		8154
	],
	"./views/Galleries": [
		57118,
		9,
		7118
	],
	"./views/Galleries.jsx": [
		57118,
		9,
		7118
	],
	"./views/Home": [
		47052,
		9
	],
	"./views/Home.jsx": [
		47052,
		9
	],
	"./views/Knowledge": [
		5445,
		9,
		5445
	],
	"./views/Knowledge.jsx": [
		5445,
		9,
		5445
	],
	"./views/News": [
		5899,
		9,
		5899
	],
	"./views/News.jsx": [
		5899,
		9,
		5899
	],
	"./views/Page": [
		53469,
		9,
		3469
	],
	"./views/Page.jsx": [
		53469,
		9,
		3469
	],
	"./views/Panorama": [
		50812,
		9,
		812
	],
	"./views/Panorama.jsx": [
		50812,
		9,
		812
	],
	"./views/Store": [
		62574,
		9,
		2574
	],
	"./views/Store.jsx": [
		62574,
		9,
		2574
	],
	"./views/Vdos": [
		29297,
		9,
		9297
	],
	"./views/Vdos.jsx": [
		29297,
		9,
		9297
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 85323;
module.exports = webpackAsyncContext;